import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';
import { useNavigate } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import Dropdown from 'react-bootstrap/Dropdown';


export default function Header({logout,selectedScreen}) {
  

	function readCurrentState(){
		if(window.location.pathname.indexOf("/dashboard")!=-1 || window.location.pathname=="/"){
			return "r";
		}else if(window.location.pathname.indexOf("/clusters")!=-1){
			return "cl";
		}else if(window.location.pathname.indexOf("/downloads")!=-1){
			return "dl";
		}else if(window.location.pathname.indexOf("/recommendations")!=-1){
			return "rc";
		}else if(window.location.pathname.indexOf("/config")!=-1){
			return "cf";
		}else if(window.location.pathname.indexOf("/maps")!=-1){
				return "mp";
		}else if(window.location.pathname.indexOf("/jobs")!=-1){
			return "jb";
		}else{
			return 'r';
		}
	}
	const [selected,setSelected] =useState(readCurrentState());
	const [logoff,setLogoff] =useState(false);
	

	var userInfo = localStorage.getItem("userInfo");
	if(userInfo){
	  userInfo = JSON.parse(userInfo);
	}





  return (
    <header className="Home_titleBar__3XDTs">
		<a href="/" className="Home_title__1dfd5">
			<span className="Home_titlePrefix__vIot9">Sulfar</span>&nbsp;&nbsp;AI
		</a>
		{userInfo  && <nav className="titlebar_mainlinks">
			<a className={selected=='r'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('r');window.history.pushState('', 'Dashboard', '/home');}}>Dashboard</a>
			{/* <a className={selected=='c'?"Home_link__3O3aj activeLink":"Home_link__3O3aj lastLink"} href="#" onClick={e=>{setSelected('c');window.history.pushState('', 'New Page Title', '/crosssell');}}>Crosssell</a> */}
			<a className={selected=='cl'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('cl');window.history.pushState('', 'Clusters', '/clusters');}}>Clusters</a>
			<a className={selected=='rc'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('rc');window.history.pushState('', 'Recommnedations', '/recommendations');}}>Recommendations</a>
			<a className={selected=='cf'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('cf');window.history.pushState('', 'Config', '/config');}}>Configure</a>
			<a className={selected=='jb'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('dl');window.history.pushState('', 'Jobs', '/jobs');}}>Jobs</a>
			<a className={selected=='dl'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('dl');window.history.pushState('', 'Downloads', '/downloads');}}>Downloads</a>
			<a className={selected=='mp'?"Home_link__3O3aj activeLink":"Home_link__3O3aj"} href="" onClick={e=>{setSelected('dl');window.history.pushState('', 'maps', '/maps');}}>Maps</a>

			<div style={{width:"120px"}}>
			<Dropdown style={{position:"absolute",top:"10px"}}>
      <Dropdown.Toggle variant="info" id="dropdown-basic" style={{color:"white"}}>
       	Sulfar Tools
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="/similaroutlets">Similar Outlets</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
			</div>
		</nav>
}
		{
			userInfo &&
		<a className="Home_link__3O3ajgithub" href="#" onClick={(e)=>setLogoff(true)}
			rel="noopener noreferrer">
			<div>{userInfo.loginId+"@"+userInfo.accountId}</div>
			
		</a>
		}
		{/* <a className="Home_link__3O3ajgithub" href="https://github.com" target="_blank" rel="noopener noreferrer">
			<div>GitHub</div>
			
		</a> */}
		{ logoff && 
		<SweetAlert style={{color:"black"}}
	warning
	showCancel
	confirmBtnText="Yes, Proceed!"
	confirmBtnBsStyle="danger"
	title="Are you sure?"
	onConfirm={()=>{setLogoff(false);logout()}}
	onCancel={()=>{setLogoff(false)}}
	focusCancelBtn
  >
	
  </SweetAlert>

		}
	</header>
	
  );
}

